<template>
  <HTag
    v-if="demands.length"
    color="blue"
    size="small"
    class="c-demand"
    @click="$emit('click')"
  >
    <WIcon :icon="icon" size="medium" />
    {{ label }}
    <span
      v-if="hasNewDemand"
      class="c-demand__new"
      data-testid="segment-new"
    ></span>
  </HTag>
</template>
<script>
import { WIcon } from '@alice-health/wonderland-vue'

import { HTag } from '@/components/shared/atoms'
import { DEMAND_ICON_MAP, DEMAND_TYPES_LABEL_MAP } from '@/models/demands'
import { checkNewDemand, getDemandLabel } from '@/utils/demands'
export default {
  components: { HTag, WIcon },
  props: {
    demands: {
      type: Array,
      default: () => []
    },
    lastSync: {
      type: Date,
      default: undefined
    }
  },
  emits: ['click'],
  data() {
    return {
      label: ''
    }
  },
  computed: {
    hasNewDemand() {
      if (!this.lastSync) {
        return false
      }
      const demand = this.demands.find(demand =>
        checkNewDemand(demand, this.lastSync)
      )
      return !!demand
    }
  },
  watch: {
    demands() {
      this.getDemandTag()
    }
  },
  created() {
    this.getDemandTag()
  },
  methods: {
    getDemandTag() {
      if (!this.demands || !this.demands.length) {
        return ''
      }
      const types = this.hasMoreThanOneType()

      if (types > 1) {
        this.icon = 'icMenuSquare'
        this.label = this.demands.length
        return
      }
      const demands = this.sortDemands()
      this.label = this.getLabel(demands[0])
      if (demands.length > 1) {
        this.label += ` + ${demands.length - 1}`
      }

      this.icon = this.getIcon(demands[0])
    },
    hasMoreThanOneType() {
      const types = this.demands.reduce((acc, current) => {
        const currentTapClassification =
          DEMAND_TYPES_LABEL_MAP[current.description.type]
        if (!acc.includes(currentTapClassification)) {
          acc.push(currentTapClassification)
        }
        return acc
      }, [])
      return types.length
    },
    sortDemands() {
      const demands = [...this.demands]
      demands.sort((a, b) => {
        if (a.startedAt?.seconds > b.startedAt?.seconds) return 1
        else if (b.startedAt?.seconds > a.startedAt?.seconds) return -1
        return 0
      })
      return demands
    },
    getIcon(demand) {
      return DEMAND_ICON_MAP[demand.description.type]
    },
    getLabel(demand) {
      return getDemandLabel(demand)
    }
  }
}
</script>
<style scoped lang="scss">
.c-demand {
  &__new {
    background: var(--sys-color-surface-container-active-variant);
    height: 8px;
    width: 8px;
    border-radius: 100%;
  }
}
</style>
